export default "__VITE_ASSET__4e243f92__"